import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
    imageBox: {
        alignContent: 'left',
    },
    logo: {
        paddingLeft: '25',
    },
    image: {
        flex: 1,
        width: '180px',
        height: '30px',
        resizeMode: 'contain',
    },
    flex: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    headerBox: {
        width: '100%',
        zIndex: 50,
        boxShadow: theme.shadows[3],
        backgroundColor: '#fff',
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
    },
    userWrap: {
        paddingLeft: '15px',
    },
    userWrapImg: {
        maxWidth: '22px',
        display: 'inline',
        float: 'left',
    },
    userWrapBox: {
        display: 'inline',
        marginLeft: '10px',
        fontSize: '14px',
    },
}))

export default useStyles
